import { BASE_URL } from '../apiSettings';

export const API_ENDPOINTS = {
    SIGNUP: `${BASE_URL}/signup`,
    LOGIN: `${BASE_URL}/login`,
    VERIFY_EMAIL: `${BASE_URL}/verify-email/`,
    SUBMIT_FORM: `${BASE_URL}/submit-form/`,
    VERIFY_USER: `${BASE_URL}/validateuser`,
    FETCH_ACTIVITY_LOGS: (userId: number) => `${BASE_URL}/activity-logs/user/${userId}`,
    FETCH_JSONS: `${BASE_URL}/infraqjsons`,
    FETCH_IMAGES: `${BASE_URL}/infraqimages`,
    FETCH_LISTS: `${BASE_URL}/infraqlistjsons`,
    RESET_PASSWORD: `${BASE_URL}/resetpassword`,
    SEND_PASSWORD_RESET_LINK: `${BASE_URL}/send-password-reset-link`,
    GET_USERNAME: `${BASE_URL}/get-username`,
    FETCH_FILE_URL: `${BASE_URL}/file`,
    VERIFY_USER_IS_ADMIN: `${BASE_URL}/validate-admin`,
};